import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const Sitemap = () => {
    const navigate = useNavigate();
    const handleClick = (path) => {
        // navigate(path);
        window.scrollTo({ top: 0, behavior: 'smooth' }); 
    };
    return (
        <>
            <div className='sitemap-wrap pt-200'>
                <div className='container'>
                    <ul className="sitemap">
                        <li>
                            <Link onClick={
                                handleClick
                            } to="/">Home</Link>
                        </li>
                        <li>
                            <Link onClick={
                                handleClick
                            } to="/cars-for-sale-boerne-tx">Inventory</Link>
                        </li>
                        <li>
                            <Link onClick={
                                handleClick
                            } to="/sell-my-exotic">Sell My Exotic</Link>
                        </li>
                        <li className='pt-4'>
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-4">
                                    <Link onClick={
                                        handleClick
                                    } to="/financing">Finance</Link>
                                    <ul className='sitemap_level2 mt-1'>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/financing">Finance</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/applyforcredit-boerne">Online Credit Approval</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/accu-trade-instant-offer">Trade In / Instant Offer</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-12 col-sm-6 col-md-4">
                                    <Link onClick={
                                        handleClick
                                    } to="/schedule-car-maintenance-or-auto-repair-boerne-tx">Services</Link>
                                    <ul className='sitemap_level2 mt-1'>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/schedule-car-maintenance-or-auto-repair-boerne-tx">Service Center</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="https://markcustomstx.com/" target="_blank">Mark Customs</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="https://markmotorsdetailing.com/" target="_blank">Mark Motors Detailing</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-coolant-flush-services-in-boerne-tx">Coolant Flush Services </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-12 col-sm-6 col-md-4">
                                    <Link onClick={
                                        handleClick
                                    } to="/contact-mark-motors-in-boerne-tx">About Us</Link>
                                    <ul className='sitemap_level2 mt-1'>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/team-mark-motors-in-boerne-tx">Our Team</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/who-is-mark">Who is Mark?</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/mark-motors-dealership-customer-reviews">Testimonials</Link>
                                        </li>
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/contact-mark-motors-in-boerne-tx">Contact Us</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li className='pt-4'>
                            <div className="sitemap_title">Unlinked Pages</div>
                            <div className="row mt-3">
                                <div className="col-12 col-sm-6 col-md-4">
                                    <ul className="sitemap_level2">
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-oil-change-service-in-boerne-tx">Oil Change Service</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/cars-for-sale-boerne-tx">Inventory</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-sell-or-trade-in-an-old-vehicle-in-boerne-tx">Sell or Trade in an Old Vehicle </Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-buy-used-audi-models-in-boerne-tx">Buy Used Audi Models</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2016-land-rover-ranger-rover-sport-for-sale-in-boerne-texas-at-mark-motors">Used 2016 Land Rover Ranger Rover Sport For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2012-porsche-911-s-for-sale-in-boerne-texas-at-mark-motors">2012 Porsche 911 S For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2018-mercedes-benz-e-class-amg-e-63-s-boerne-tx-78006">2018 Mercedes-Benz E-Class AMG E 63 S Boerne, TX 78006</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/df-test">df test</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2018-mercedes-benz-e-class-amg-e-63-s-san-antonio-tx-78216"> 2018 Mercedes-Benz E-Class AMG E 63 S San Antonio, TX 78216</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-gmc-vehicles-in-boerne-tx">Used GMC Vehicles</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2014-mercedes-benz-g-class-for-sale-in-boerne-texas-at-mark-motors">Used 2014 Mercedes-Benz G-Class For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2017-mercedes-benz-e300-in-boerne-texas-at-mark-motors">Used 2017 Mercedes-Benz E300 in Boerne, Texas at Mark Motors </Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-g-class-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz G-Class in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/404">Oops</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2017-mercedes-benz-g-class-in-boerne-texas-at-mark-motors">Used 2017 Mercedes-Benz G-Class in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/contact-mark-motors-in-boerne-tx">Sell Us Your Car</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2014-land-rover-range-rover-supercharged-for-sale-in-boerne-texas-at-mark-motors">Used 2014 Land Rover Range Rover Supercharged For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-mercedes-benz-san-antonio-tx-mark-motors-luxury-used-car-dealership">Used Mercedes-Benz in San Antonio, Texas- Mark Motors Luxury Used Car Dealership</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/schedule-car-maintenance-or-auto-repair-boerne-tx">Service Center</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-toyota-vehicles-in-boerne-tx">Used Toyota Vehicles</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/thank-you">Thank You</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/applyforcredit-boerne">Online Credit Approval</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-slk-class-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz SLK-Class in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/mark-motors-dealership-customer-reviews">Testimonials</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/mark-motors-luxury-used-car-dealership-in-boerne-tx">Mark Motors - Luxury Used Car Dealership in Boerne, TX</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2015-mercedes-benz-e-class-for-sale-in-san-antonio">2015 Mercedes-Benz E Class for Sale in San Antonio</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/blog">Our Blog</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-2024-mercedes-benz-gls-in-boerne-tx">Used 2024 Mercedes-Benz GLS </Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/caleb-scratch-page">caleb-scratch-page</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/land-rover-service-in-boerne-and-san-antonio-texas-at-mark-motors">Land Rover Service in Boerne and San Antonio, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/sell-my-exotic">Sell My Exotic</Link>
                                        </li>

                                    </ul>
                                </div>
                                <div className="col-12 col-sm-6 col-md-4">
                                    <ul className="sitemap_level2">
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2015-mercedes-benz-slk350-for-sale-in-boerne-texas-at-mark-motors">2015 Mercedes-Benz SLK350 For Sale In Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/team-mark-motors-in-boerne-tx">Our Team</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/privacy">Privacy</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-jeep-vehicles-in-boerne-tx">Used Jeep Vehicles</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2016-lamborghini-aventador-for-sale-in-boerne-texas">2016 Lamborghini Aventador For Sale in Boerne, Texas</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-lamborghini-huracan-in-boerne-tx">Used Lamborghini Huracan </Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2016-land-rover-range-rover-supercharged-boerne-tx-78006-mark-motors">2016 Land Rover Range Rover Supercharged Boerne, TX 78006 - Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2015-land-rover-range-rover-sport-supercharged-for-sale-in-boerne">2015 Land Rover Range Rover Sport Supercharged For Sale In Boerne</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/service-products">Service Products</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2016-land-rover-range-rover-sport-for-sale-in-san-antonio-texas-at-mark-motors">2016 Land Rover Range Rover Sport for Sale in San Antonio, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/contact-mark-motors-in-boerne-tx">Contact Us</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2015-cadillac-escalade-for-sale-in-boerne-texas-at-mark-motors">2015 Cadillac Escalade for Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/">Home</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2014-land-rover-range-rover-for-sale-in-boerne-texas-at-mark-motors">Used 2014 Land Rover Range Rover For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/copy-of-contact-mark-motors-in-boerne-tx">Copy of Contact Us</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-porsche-cayenne-in-boerne-tx">Used Porsche Cayenne</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/who-is-mark">Who is Mark?</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-coolant-flush-services-in-boerne-tx">Coolant Flush Services </Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2011-land-rover-range-rover-for-sale-in-boerne-texas-at-mark-motors">Used 2011 Land Rover Range Rover For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/financing">Finance</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/lamborghini-for-sale-in-san-antonio-texas-at-mark-motors">Lamborghini For Sale in San Antonio, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-cla45-for-sale-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz CLA45 For Sale In Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-ford-mustang-in-boerne-tx">Used Ford Mustang</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/service-center-new">service-center-new</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-c-class-sedan-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz C-Class Sedan in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/car-service-boerne-texas">Car service Boerne Texas</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-gla-class-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz GLA-Class in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2017-cadillac-escalade-for-sale-in-san-antonio">2017 Cadillac Escalade For Sale In San Antonio</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/sell-my-exotic-license">Sell My Exotic - License</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2016-mercedes-benz-gle350-for-sale-in-boerne-texas-at-mark-motors">Used 2016 Mercedes-Benz GLE350 For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-exotic-vehicle-inspection-in-boerne-tx">Exotic Vehicle Inspection </Link>
                                        </li>

                                    </ul>
                                </div>
                                <div className="col-12 col-sm-6 col-md-4">
                                    <ul className="sitemap_level2">
                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-lamborghini-models-in-boerne-tx">Used Lamborghini Models </Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/sell-my-exotic-make-model">Sell My Exotic - Make/Model</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/porsche-for-sale-in-boerne-texas-at-mark-motors">Porsche for Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/sitemap">Sitemap</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-ferraris-san-antonio-tx-mark-motors-luxury-used-car-dealership">Used Ferraris in San Antonio, Texas - Mark Motors Luxury Used Car Dealership</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-c300-sport-4matic-sedan-for-sale-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale In Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2">Co-Applicant Finance</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/accu-trade-instant-offer">Trade In / Instant Offer</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2017-ford-f-150-raptor-for-sale-in-boerne-texas-at-mark-motors">2017 Ford F-150 Raptor for Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-luxury-used-car-dealership-texas">Used Luxury Cars for Sale | Mark Motors in Boerne, Texas</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-get-an-auto-loan-in-boerne-texas">Get an Auto Loan in Boerne, Texas </Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2016-mercedes-benz-c-class-in-boerne-texas-at-mark-motors">Used 2016 Mercedes-Benz C-Class in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2017-mercedes-benz-e300-4matic-in-boerne-texas-at-mark-motors">Used 2017 Mercedes-Benz E300 4MATIC in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/mercedes-benz-amg-gt-r-for-sale-in-boerne-texas">Mercedes-Benz AMG GT R For Sale In Boerne, Texas</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2016-mercedes-benz-glc-class-in-boerne-texas-at-mark-motors">Used 2016 Mercedes-Benz GLC-Class in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-c300-sedan-for-sale-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz C300 Sedan For Sale In Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-mercedes-benz-g-class-in-boerne-tx">Used Mercedes Benz G-Class in Boerne, TX</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-slk55-amg-for-sale-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz SLK55 AMG For Sale In Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/sell-my-exotic-vin">Sell My Exotic - VIN</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2015-mercedes-benz-cla250-for-sale-in-boerne-texas-at-mark-motors">Used 2015 Mercedes-Benz CLA250 For Sale In Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-nissan-vehicles-in-boerne-tx">Used Nissan Vehicles</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-rolls-royce-in-boerne-tx">Used Rolls Royce in Boerne, TX</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/mercedes-benz-for-sale-in-boerne-texas-at-mark-motors">Mercedes-Benz For Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2015-bmw-m4-for-sale-in-boerne-texas-at-mark-motors">2015 BMW M4 for Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-2024-mclaren-in-boerne-tx">Used 2024 McLaren in Boerne, TX</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/find-a-car-in-boerne-tx">Car Finder</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/used-2016-mercedes-benz-g-class-in-boerne-texas-at-mark-motors">Used 2016 Mercedes-Benz G-Class in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/deliver-nationwide">Nationwide Delivery</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/2015-audi-r8-for-sale-in-boerne-texas-at-mark-motors">2015 Audi R8 for Sale in Boerne, Texas at Mark Motors</Link>
                                        </li>

                                        <li>
                                            <Link onClick={
                                                handleClick
                                            } to="/clp-used-2025-mercedes-benz-g-class-in-boerne-tx">Used 2025 Mercedes-Benz G-Class in Boerne, TX </Link>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </>
    )
}

export default Sitemap